import {
  colors,
  typography
} from "./chunk-LXMSSK5D.js";

// src/MenderNext/light.ts
import { outlinedInputClasses } from "@mui/material";
import { common } from "@mui/material/colors";
var info = {
  main: common.white,
  dark: colors.grey[300],
  light: colors.grey[100],
  contrastText: common.black
};
var palette = {
  ...colors,
  mode: "light",
  primary: {
    main: colors.purple[700],
    dark: colors.purple[800],
    light: colors.purple[400]
  },
  secondary: {
    main: colors.cyan[700],
    dark: colors.cyan[900],
    light: colors.cyan[500]
  },
  info,
  neutral: info,
  text: {
    primary: colors.grey[900],
    secondary: colors.grey[700],
    disabled: colors.grey[500]
  }
};
var light = {
  palette,
  typography,
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&:hover": {
            borderColor: common.black
          },
          [`&.${outlinedInputClasses.disabled}`]: {
            borderColor: common.black
          }
        }
      }
    }
  }
};

export {
  light
};
//# sourceMappingURL=chunk-JECPLRHH.js.map